import {useState} from 'react'
import InsectDiseasePestForm from './InsectDiseasePestForm';
import InsectDiseasePestList from './InsectDiseasePestList';

const InsectDiseasePest = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <InsectDiseasePestForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <InsectDiseasePestList addForm={setFromIsShown} update={setUpData} sId={setServiceId} />
        )}
  
    </>
  )
}

export default InsectDiseasePest